import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class TextAlign extends BaseOption {
  static userInterfaceComponent = {
    label: "Text Align",
    component: inspectorTools.RADIO_BAR,
    props: {
      iconSize: 15,
      options: [
        {
          icon: "left-align",
          value: "left",
        },
        {
          icon: "center-align",
          value: "center",
        },
        {
          icon: "right-align",
          value: "right",
        },
      ],
    },
  };

  static defaultValue = "left";
}
